import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './PricingSection.css';


const PricingSectionForHome = () => {

  const [pricing, setPricing] = useState([]);


  useEffect(() => {
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/pricings`)
      .then((res) => res.json())
      .then((info) => setPricing(info));
  }, []);

  return (


    <>

      <section className="pricing" id="pricing-sec">
        <div className="pricing__wrapper">
          <h2 className="section-heading color-black">Easy pricing plans for your needs.</h2>
          <div className="container">
            <div className="row">
              {
                pricing.map(b => b.pageSlug === '' && <div className="col-lg-4">
                  <div className="pricing__single pricing__single-1">
                    <div className="icon">
                    <i className="fas fa-dollar-sign" />
                    </div>
                    <h4>{b.packageName} Plan</h4>
                    <h3>${b.packagePrice}</h3>
                    
                    <div className="list">
                      <ul>
                        <li>{b.packagePointOne}</li>
                        <li>{b.packagePointTwo}</li>
                        <li>{b.packagePointThree}</li>
                        <li>{b.packagePointFour}</li>
                        <li>{b.packagePointFive}</li>
                        <li>{b.packagePointSix}</li>
                      </ul>
                    </div>
                    <Link to={`/order-now/${b._id}`} className="button">  <span>{b.packageButtonText}</span> <i className="fad fa-long-arrow-right" /></Link>
                  </div>
                </div>)}



            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PricingSectionForHome;